import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center mb-6 cursor-pointer">
              <div>
                <h3 className="font-bold text-xl">NS Electrical WA</h3>
                <p className="text-xs text-gold tracking-wider">LICENSED & INSURED</p>
              </div>
            </Link>
            <p className="text-sm text-gray-300 leading-relaxed">
              Professional electrical services across Western Australia. Licensed, insured, and committed to excellence.
            </p>
          </div>

          <div>
            <h3 className="text-gold font-bold text-sm tracking-wider mb-4">QUICK LINKS</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/" className="text-sm hover:text-gold transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/commercial-services" className="text-sm hover:text-gold transition-colors cursor-pointer">
                Commercial Services
              </Link>
              <Link to="/about" className="text-sm hover:text-gold transition-colors cursor-pointer">
                About Us
              </Link>
              <Link to="/contact" className="text-sm hover:text-gold transition-colors cursor-pointer">
                Contact
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-gold font-bold text-sm tracking-wider mb-4">OUR SERVICES</h3>
            <div className="grid grid-cols-1 gap-3 text-sm">
              <span className="hover:text-gold transition-colors cursor-pointer">Commercial Fit-Outs</span>
              <span className="hover:text-gold transition-colors cursor-pointer">Switchboard Installations</span>
              <span className="hover:text-gold transition-colors cursor-pointer">Compliance Testing</span>
              <span className="hover:text-gold transition-colors cursor-pointer">Fault Finding</span>
              <span className="hover:text-gold transition-colors cursor-pointer">Lighting Installations</span>
              <span className="hover:text-gold transition-colors cursor-pointer">Preventative Maintenance</span>
            </div>
          </div>

          <div>
            <h3 className="text-gold font-bold text-sm tracking-wider mb-4">CONTACT US</h3>
            <div className="space-y-4">
              <a href="tel:+61400000000" className="flex items-center gap-3 hover:text-gold transition-colors cursor-pointer">
                <i className="ri-phone-fill text-gold text-lg w-5 h-5 flex items-center justify-center"></i>
                <span className="font-semibold">0400 000 000</span>
              </a>
              <a href="mailto:info@nselectricalwa.com.au" className="flex items-center gap-3 hover:text-gold transition-colors cursor-pointer">
                <i className="ri-mail-fill text-gold text-lg w-5 h-5 flex items-center justify-center"></i>
                <span className="text-sm">info@nselectricalwa.com.au</span>
              </a>
              <div className="flex items-center gap-3">
                <i className="ri-map-pin-fill text-gold text-lg w-5 h-5 flex items-center justify-center"></i>
                <span className="text-sm">Western Australia</span>
              </div>
              <Link
                to="/contact"
                className="inline-block border-2 border-gold text-gold px-6 py-2 rounded-lg font-semibold text-sm hover:bg-gold hover:text-navy transition-all whitespace-nowrap cursor-pointer"
              >
                REQUEST QUOTE
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gold/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
            <p>&copy; 2025 NS Electrical WA. All rights reserved.</p>
            <div className="flex items-center gap-2">
              <span className="text-gold font-semibold">AS/NZS 3000 Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;